import React from 'react'

export const LogoIcon = () => {
  return (
    <svg
      width="106"
      height="26"
      viewBox="0 0 106 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.0238 25.4967C48.7458 25.4866 48.4691 25.4521 48.1971 25.3941C47.5498 25.2548 46.9431 24.9708 46.4232 24.5638C45.9033 24.1569 45.4839 23.638 45.197 23.0461C44.981 22.5993 44.8459 22.1186 44.7977 21.6255C44.7769 21.466 44.7696 18.861 44.7696 13.4167V5.44189H34.7787V1.07057H44.9249C51.7985 1.07057 55.1329 1.07996 55.2732 1.09609C56.0966 1.20018 56.874 1.53125 57.5165 2.05235C58.1591 2.57345 58.641 3.26349 58.9071 4.04306C59.0431 4.46137 59.1206 4.89574 59.1376 5.33491V5.44623H49.1467V25.5L49.0238 25.4967ZM42.0235 25.3985C40.2373 25.1803 38.5267 24.5535 37.0267 23.5674C36.2659 23.067 35.569 22.4775 34.9514 21.8107C34.7894 21.64 33.7136 20.3608 32.5554 18.9745C31.3972 17.5883 30.4386 16.4549 30.4268 16.4549C30.4151 16.4549 29.4447 17.876 28.268 19.6115C27.0913 21.3469 26.0548 22.8632 25.9684 22.9739C25.6859 23.3044 25.3756 23.6103 25.0408 23.8889C24.3137 24.4465 23.4738 24.8421 22.5785 25.0487C21.8595 25.2039 22.6677 25.1924 12.794 25.2041C6.45609 25.2096 3.7521 25.204 3.51934 25.1823C3.02377 25.1559 2.53947 25.0261 2.09811 24.8011C1.57281 24.5414 1.11558 24.1637 0.762536 23.6988C0.409493 23.2339 0.17026 22.6942 0.0637678 22.1219C0.0121672 21.86 0.00767523 21.8156 0.00262734 17.9678C-0.00410319 15.3777 0.00264103 13.9581 0.0166629 13.7278C0.0445596 13.2139 0.184032 12.7118 0.425544 12.2563C0.687876 11.7515 1.0622 11.3123 1.52032 10.9715C1.97844 10.6306 2.50849 10.397 3.07068 10.2884L3.31298 10.233L11.9769 10.2254L20.6429 10.2183L20.6216 10.4876C20.5744 11.3592 20.2768 12.1989 19.764 12.9084C19.4594 13.2949 19.1092 13.6439 18.7208 13.9478C18.1162 14.3724 17.4221 14.6552 16.691 14.7742C16.484 14.8109 15.9344 14.8153 10.541 14.8231L4.61418 14.8318V20.9316L12.3408 20.9245C19.5716 20.9145 20.0742 20.9129 20.2694 20.8756C20.718 20.7841 21.1452 20.6095 21.5285 20.3608C21.9632 20.0773 21.9846 20.0532 24.9538 16.2893C26.7442 14.0195 27.7279 12.7525 27.7189 12.7347C27.6673 12.6551 22.1208 5.79773 22.0221 5.69819C21.7671 5.44652 21.4532 5.26154 21.1084 5.15952C20.9699 5.11726 20.4578 5.11515 10.5774 5.10847L0.189404 5.10413V4.99281C0.201239 4.72297 0.235805 4.45437 0.292651 4.19022C0.501081 3.21927 1.0164 2.33945 1.76372 1.67875C2.51104 1.01805 3.45139 0.611221 4.44815 0.516686C4.56033 0.505565 8.50779 0.498171 13.2203 0.500395C21.2543 0.505956 21.8017 0.508171 22.03 0.547095C23.2353 0.731333 24.3356 1.33306 25.1356 2.24567C25.3397 2.48032 43.4684 25.472 43.4566 25.4837C43.4372 25.4872 43.4174 25.4882 43.3977 25.487C43.1627 25.4914 42.327 25.4379 42.0235 25.399V25.3985ZM91.6611 25.4718V14.0167L91.3274 13.5899C90.9842 13.1579 81.6983 1.08545 81.6607 1.02984C81.6467 1.00704 82.2009 0.999975 84.4001 0.999975H87.1579L90.4985 5.34143L93.8391 9.68614L94.0315 9.43201C94.1397 9.29077 95.6428 7.33706 97.372 5.08838L100.517 0.999975H103.266C104.177 0.963563 105.09 0.975177 106 1.03419C105.988 1.0681 96.9137 12.8537 96.3355 13.5899L96.0394 13.9635L96.0343 17.8526L96.0276 21.7369L95.9715 22.0002C95.8584 22.5598 95.6344 23.0914 95.3127 23.5647C94.9909 24.038 94.5778 24.4437 94.097 24.7577C93.4137 25.1989 92.6215 25.4462 91.8064 25.4723L91.6611 25.4718ZM66.4335 25.1807C64.6666 24.9005 63.0522 24.022 61.865 22.6948C60.6778 21.3675 59.991 19.6736 59.9217 17.901L59.9054 17.523H64.2584L64.2747 17.7451C64.3208 18.3608 64.5291 18.9535 64.8787 19.4643C65.1299 19.7926 65.4266 20.0844 65.7599 20.3304C66.1562 20.5921 66.6035 20.7681 67.0729 20.8474C67.2939 20.8852 67.7167 20.8899 71.5341 20.8832L75.7508 20.8762L76.0042 20.8088C76.6301 20.6508 77.1984 20.3211 77.6437 19.8575C78.0918 19.3901 78.3972 18.8069 78.5248 18.1746C78.587 17.761 78.587 17.3404 78.5248 16.9268C78.4007 16.2898 78.0913 15.7027 77.6348 15.238C77.1607 14.7371 76.542 14.3934 75.8635 14.2546L75.6285 14.1992L70.6928 14.1851C66.1844 14.1689 65.7357 14.1647 65.5198 14.1297C64.0921 13.9176 62.7767 13.2393 61.7821 12.202C61.4987 11.9161 61.2459 11.6016 61.0278 11.2642C60.5771 10.5895 60.2524 9.84039 60.0692 9.05189C59.9478 8.555 59.8987 8.0432 59.9234 7.53252C59.9011 7.04647 59.9422 6.55989 60.0456 6.08428C60.3359 4.66584 61.092 3.38247 62.1957 2.43518C63.2995 1.48789 64.6888 0.93007 66.1463 0.848472C66.226 0.844023 68.6764 0.841904 71.5919 0.844128C77.2158 0.848576 77.0116 0.844015 77.6196 0.964678C78.767 1.19417 79.8327 1.72109 80.708 2.49165C81.5832 3.26222 82.2369 4.24873 82.6024 5.3512C82.8033 5.93194 82.9119 6.54022 82.9244 7.15403L82.9384 7.60365H78.5877L78.5737 7.34735C78.5635 7.06758 78.4963 6.79268 78.3762 6.53933C78.2351 6.23526 78.0277 5.96641 77.7689 5.75141C77.5101 5.53641 77.2065 5.38096 76.8798 5.29636L76.6734 5.24043H66.1704L65.9634 5.29636C65.8172 5.33632 65.6749 5.38945 65.5383 5.45492C65.1285 5.65246 64.7882 5.9675 64.5619 6.35959C64.3356 6.75169 64.2337 7.20272 64.2696 7.65307C64.2867 8.09001 64.432 8.51209 64.6878 8.86835C64.9435 9.22461 65.2986 9.49928 65.7094 9.65845C66.111 9.80914 65.7234 9.79762 71.1174 9.81375C76.5321 9.82988 76.0861 9.81381 76.8422 9.9734C78.0075 10.228 79.0976 10.746 80.0275 11.4873C80.8688 12.1703 81.5623 13.0147 82.0663 13.97C82.6502 15.0723 82.9472 16.302 82.9305 17.5469C82.9435 18.4048 82.8061 19.258 82.5244 20.0692C82.0883 21.3408 81.3234 22.4768 80.3061 23.3638C79.2887 24.2507 78.0546 24.858 76.7267 25.1242C75.9701 25.271 76.1911 25.2641 71.7254 25.2746C70.828 25.2746 70.1044 25.2779 69.5121 25.2779C68.4859 25.3259 67.4574 25.2935 66.4363 25.1807H66.4335Z"
        fill="url(#paint0_linear_3876_26491)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3876_26491"
          x1="7.102"
          y1="3.05"
          x2="17.9673"
          y2="44.4018"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E4192" />
          <stop offset="1" stopColor="#5E7AA1" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const EventAttendings = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.75"
        width="21.5"
        height="21.5"
        rx="10.75"
        fill="#6374A0"
        fillOpacity="0.1"
      />
      <g filter="url(#filter0_d_157_4191)">
        <path
          d="M11.6 8.92858C11.6 10.3489 10.5256 11.5 9.2 11.5C7.87438 11.5 6.8 10.3489 6.8 8.92858C6.8 7.50826 7.87438 6.35715 9.2 6.35715C10.5256 6.35715 11.6 7.50826 11.6 8.92858ZM5 16.0462C5 14.0674 6.49625 12.4643 8.34313 12.4643H10.0569C11.9038 12.4643 13.4 14.0674 13.4 16.0462C13.4 16.3757 13.1506 16.6429 12.8431 16.6429H5.55688C5.24938 16.6429 5 16.3757 5 16.0462ZM16.4244 16.6429H13.8387C13.94 16.454 14 16.235 14 16V15.8393C14 14.6199 13.4919 13.525 12.6913 12.7897C12.7363 12.7877 12.7794 12.7857 12.8244 12.7857H13.9756C15.6463 12.7857 17 14.2362 17 16.0261C17 16.3676 16.7413 16.6429 16.4244 16.6429ZM13.1 11.5C12.5188 11.5 11.9938 11.2469 11.6131 10.8391C11.9825 10.3047 12.2 9.64375 12.2 8.92858C12.2 8.39018 12.0763 7.88192 11.8569 7.43594C12.2056 7.16273 12.635 7 13.1 7C14.2606 7 15.2 8.00648 15.2 9.25C15.2 10.4935 14.2606 11.5 13.1 11.5Z"
          fill="#6374A0"
        />
      </g>
      <rect
        x="0.25"
        y="0.75"
        width="21.5"
        height="21.5"
        rx="10.75"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <filter
          id="filter0_d_157_4191"
          x="4"
          y="6.35715"
          width="14"
          height="12.2857"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_157_4191"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_157_4191"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export const EventDuration = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="21.5"
        height="21.5"
        rx="10.75"
        fill="#5B8FF4"
      />
      <g clipPath="url(#clip0_157_4205)">
        <g filter="url(#filter0_d_157_4205)">
          <path
            d="M9.2 11C7.87438 11 6.8 9.92562 6.8 8.6C6.8 7.27437 7.87438 6.2 9.2 6.2C10.5256 6.2 11.6 7.27437 11.6 8.6C11.6 9.92562 10.5256 11 9.2 11ZM8.34313 11.9H10.0569C10.4431 11.9 10.8144 11.9656 11.1594 12.0856C11.0563 12.4062 11 12.7456 11 13.1C11 14.2156 11.5531 15.2019 12.4025 15.8H5.55688C5.24938 15.8 5 15.5506 5 15.2431C5 13.3962 6.49625 11.9 8.34313 11.9ZM17 13.1C17 14.5906 15.7906 15.8 14.3 15.8C12.8094 15.8 11.6 14.5906 11.6 13.1C11.6 11.6094 12.8094 10.4 14.3 10.4C15.7906 10.4 17 11.6094 17 13.1ZM14.3 11.6C14.135 11.6 14 11.735 14 11.9V13.1C14 13.265 14.135 13.4 14.3 13.4H15.2C15.365 13.4 15.5 13.265 15.5 13.1C15.5 12.935 15.365 12.8 15.2 12.8H14.6V11.9C14.6 11.735 14.465 11.6 14.3 11.6Z"
            fill="white"
          />
        </g>
      </g>
      <rect
        x="0.25"
        y="0.25"
        width="21.5"
        height="21.5"
        rx="10.75"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <filter
          id="filter0_d_157_4205"
          x="4"
          y="6.2"
          width="14"
          height="11.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_157_4205"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_157_4205"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_157_4205">
          <rect
            width="12"
            height="9.6"
            fill="white"
            transform="translate(5 6.2)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const EventOccurTime = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="21.5"
        height="21.5"
        rx="10.75"
        fill="#5B8FF4"
      />
      <g filter="url(#filter0_d_157_4210)">
        <path
          d="M11 17C7.68594 17 5 14.3141 5 11C5 7.68594 7.68594 5 11 5C14.3141 5 17 7.68594 17 11C17 14.3141 14.3141 17 11 17ZM10.4375 7.8125V11C10.4375 11.1875 10.5312 11.3633 10.6883 11.4688L12.9383 12.9688C13.1961 13.1422 13.5453 13.0719 13.7188 12.8117C13.8922 12.5516 13.8219 12.2047 13.5617 12.0312L11.5625 10.7V7.8125C11.5625 7.50078 11.3117 7.25 11 7.25C10.6883 7.25 10.4375 7.50078 10.4375 7.8125Z"
          fill="white"
        />
      </g>
      <rect
        x="0.25"
        y="0.25"
        width="21.5"
        height="21.5"
        rx="10.75"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <filter
          id="filter0_d_157_4210"
          x="4"
          y="5"
          width="14"
          height="14"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_157_4210"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_157_4210"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export const EventOnline = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.392857"
        width="19.5"
        height="20.2143"
        rx="9.75"
        fill="#5B8FF4"
      />
      <g filter="url(#filter0_d_157_4218)">
        <path
          d="M4 7.92857C4 7.21942 4.59792 6.64286 5.33333 6.64286H10.6667C11.4021 6.64286 12 7.21942 12 7.92857V13.0714C12 13.7806 11.4021 14.3571 10.6667 14.3571H5.33333C4.59792 14.3571 4 13.7806 4 13.0714V7.92857ZM15.6479 7.36205C15.8646 7.47455 16 7.69152 16 7.92857V13.0714C16 13.3085 15.8646 13.5254 15.6479 13.6379C15.4312 13.7504 15.1688 13.7384 14.9625 13.6058L12.9625 12.3201L12.6667 12.1292V11.7857V9.21429V8.87076L12.9625 8.67991L14.9625 7.3942C15.1667 7.26362 15.4292 7.24955 15.6479 7.36205Z"
          fill="white"
        />
      </g>
      <rect
        x="0.25"
        y="0.392857"
        width="19.5"
        height="20.2143"
        rx="9.75"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <filter
          id="filter0_d_157_4218"
          x="3"
          y="6.64286"
          width="14"
          height="9.71429"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_157_4218"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_157_4218"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export const EventLocation = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#5B8FF4" />
      <g filter="url(#filter0_d_212_3999)">
        <path
          d="M10.515 15.5712C11.6283 14.1045 14.1673 10.5497 14.1673 8.55302C14.1673 6.13139 12.301 4.16667 10.0007 4.16667C7.7003 4.16667 5.83398 6.13139 5.83398 8.55302C5.83398 10.5497 8.37305 14.1045 9.48633 15.5712C9.75325 15.9207 10.248 15.9207 10.515 15.5712ZM10.0007 10.0151C9.23459 10.0151 8.61176 9.35947 8.61176 8.55302C8.61176 7.74657 9.23459 7.0909 10.0007 7.0909C10.7667 7.0909 11.3895 7.74657 11.3895 8.55302C11.3895 9.35947 10.7667 10.0151 10.0007 10.0151Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_212_3999"
          x="4.83398"
          y="4.16667"
          width="10.334"
          height="13.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_212_3999"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_212_3999"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export const DeleteEvent = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#FEE4E2" />
      <path
        d="M28 24V28M28 32H28.01M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z"
        stroke="#D51646"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#FEF3F2"
        strokeWidth="8"
      />
    </svg>
  )
}

export const BitCoin = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.4987" cy="12.5002" r="10.4167" fill="#F7931A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2902 12.4713C14.9209 12.3183 15.398 11.8896 15.5296 11.0073C15.7111 9.80212 14.8237 9.15966 13.6077 8.73484L14.0115 7.10158L13.0476 6.85976L12.6542 8.44989C12.4014 8.38584 12.1414 8.32571 11.8828 8.26689L12.2789 6.66565L11.3156 6.42383L10.9118 8.05644C10.7018 8.00873 10.4956 7.96102 10.296 7.91069L10.2973 7.90612L8.96846 7.57149L8.70594 8.63288C8.70594 8.63288 9.42091 8.79824 9.40535 8.80804C9.79622 8.90673 9.86558 9.17208 9.85262 9.38318L9.39239 11.2439C9.42657 11.2525 9.46014 11.2634 9.49286 11.2766L9.39045 11.2511L8.74613 13.8575C8.69751 13.9797 8.57565 14.1634 8.30211 14.0961C8.31183 14.1098 7.60205 13.9196 7.60205 13.9196L7.11719 15.0581L8.37147 15.3738C8.51279 15.4094 8.6522 15.446 8.7903 15.4822L8.79035 15.4822L8.79037 15.4822L8.79076 15.4823L8.7927 15.4828C8.88182 15.5062 8.97039 15.5295 9.05856 15.5522L8.65019 17.2044L9.61213 17.4462L10.0166 15.8123C10.2717 15.8821 10.5275 15.9489 10.7841 16.013L10.3816 17.6403L11.3448 17.8822L11.7532 16.2339C13.397 16.5443 14.6351 16.4084 15.164 14.8744C15.5899 13.6392 15.153 12.9307 14.2902 12.4713ZM18.6553 16.3515L19.0085 14.9248L20.4236 15.2809L20.6589 14.3294L19.2438 13.9738L19.5964 12.5471L18.6533 12.3098L18.3 13.7366L16.885 13.381L16.6497 14.332L18.0647 14.6875L17.7121 16.1149L18.6553 16.3515ZM13.3082 14.2C13.5943 13.0426 11.9298 12.6668 11.1158 12.4831C11.0243 12.4624 10.9435 12.4442 10.8774 12.4275L10.3375 14.615C10.3916 14.6285 10.455 14.6454 10.5259 14.6643L10.5261 14.6644C11.3128 14.874 13.0301 15.3317 13.3095 14.1993L13.3082 14.2ZM11.8149 9.48644C12.4936 9.63741 13.8838 9.94667 13.6239 11.0001C13.3687 12.0306 11.9359 11.6436 11.2815 11.4669C11.2229 11.451 11.1704 11.4369 11.1257 11.4256L11.6164 9.4407C11.6713 9.4545 11.7386 9.46947 11.8149 9.48644Z"
        fill="white"
      />
    </svg>
  )
}
export const Digibyte = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4989 22.9167C18.2519 22.9167 22.9157 18.2529 22.9157 12.4999C22.9157 6.74679 18.2519 2.08301 12.4989 2.08301C6.74581 2.08301 2.08203 6.74679 2.08203 12.4999C2.08203 18.2529 6.74581 22.9167 12.4989 22.9167Z"
        fill="#0066CC"
      />
      <path
        d="M6.66045 9.79478H14.0163C14.0163 9.79478 16.5553 9.77105 14.7993 13.0456C14.7993 13.0456 13.518 15.6083 10.3384 15.5608L12.0516 11.1853C12.0723 11.1334 12.0801 11.0773 12.0744 11.0217C12.0687 10.9662 12.0497 10.9128 12.0189 10.8662C11.9881 10.8196 11.9466 10.7811 11.8977 10.754C11.8489 10.727 11.7942 10.7121 11.7384 10.7107L9.48415 10.6727L6.63672 17.6015C6.63672 17.6015 7.58586 17.6964 8.10789 17.6489L7.82315 18.3608H9.16618C9.20343 18.3611 9.23984 18.3498 9.27044 18.3286C9.30103 18.3073 9.32429 18.2772 9.33703 18.2422L9.57906 17.6015L10.1485 17.554L9.81635 18.3608H11.1262C11.1744 18.3611 11.2215 18.3468 11.2614 18.3197C11.3012 18.2925 11.3319 18.2539 11.3492 18.2089L11.7146 17.2693C11.7146 17.2693 15.701 16.6049 17.5044 13.3778C17.5044 13.3778 19.9247 9.62868 17.0773 8.29988C16.5223 8.04542 15.9289 7.88504 15.3214 7.82531L15.6536 7.0043C15.6637 6.97994 15.6676 6.95348 15.6651 6.92723C15.6626 6.90099 15.6537 6.87576 15.6392 6.85375C15.6247 6.83174 15.605 6.81363 15.5818 6.80099C15.5587 6.78835 15.5328 6.78157 15.5065 6.78125H14.2773L13.8977 7.77785H13.3756L13.6699 7.0043C13.6789 6.97953 13.6819 6.95297 13.6787 6.9268C13.6754 6.90063 13.666 6.87561 13.6512 6.85382C13.6363 6.83202 13.6165 6.81407 13.5933 6.80145C13.5702 6.78883 13.5444 6.78191 13.518 6.78125H12.2841L11.9045 7.77785H8.06992C7.96687 7.77751 7.86565 7.80513 7.77706 7.85778C7.68847 7.91044 7.61583 7.98614 7.56688 8.07683L6.66045 9.79478Z"
        fill="white"
      />
    </svg>
  )
}
